import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInstallment, IPixQRCodePayment } from 'v3/data/store/installments/types';
import { installmentsInitialState } from 'v3/data/store/installments/state';
import { IInstallmentResponse } from 'v3/services/interfaces/response';

export const installmentsSlice = createSlice({
  name: 'installments',
  initialState: installmentsInitialState,
  reducers: {
    setInstallmentsList: (state, action: PayloadAction<IInstallmentResponse>) => {
      state.item = action.payload;
      return state;
    },
    setInstallmentsToPay: (state, action: PayloadAction<IInstallment[]>) => {
      state.itemsToPay = action.payload;
      return state;
    },
    setTotalToPay: (state, action: PayloadAction<number>) => {
      state.totalToPay = action.payload;
      return state;
    },
    setIntallmentContractingKey: (state, action: PayloadAction<string>) => {
      state.contractingKey = action.payload;
      return state;
    },
    setPixQRCodePayment: (state, action: PayloadAction<IPixQRCodePayment>) => {
      state.pix = action.payload;
      return state;
    },
  },
});
